import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange} from "@angular/core";
import {FieldType} from "../../../../../../../models/field-type";
import FormUtils from "../../../../../../utils/form-utils.component";

@Component({
  selector: "field-set-required-rows",
  templateUrl: "./field-set-required-rows.component.html",
  styles: [],
})
export class FieldSetRequiredRowsComponent implements OnInit, OnChanges {
  @Input() public guides: any[];
  @Input() public fieldOptions: any;
  @Output() public dataChanged = new EventEmitter();

  public visibleGuides: any[];

  public ngOnInit() {
    this.geanerateGuidesFormioIds();
    this.filterOptions();
  }

  public ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    if (changes.guides && changes.guides.currentValue) {
      this.guides = changes.guides.currentValue;
      }
    this.geanerateGuidesFormioIds();
    this.filterOptions(); }

  public dataChangedEvent(event) {
    this.dataChanged.emit(event);
  }

  public filterOptions() {
    this.visibleGuides = this.guides ? this.guides.filter((guide) => guide.type === FieldType.NUMERIC.toString()) : [];
  }

    public geanerateGuidesFormioIds() {
        if (this.guides) {
            this.guides.forEach((guide) => {
                guide.formIoId = FormUtils.generateGuideIdFromTitle(guide.title);
            });
        }
    }
}
